export { default as useLocalStorage } from './useLocalStorage';
export * from './useLocalStorage';
//# sourceMappingURL=index.js.map